import f1 from "../image1/Frame 778.png"
import f2 from "../image1/Frame 820.png"
import f3 from "../image1/Group.png"
import f4 from "../image1/Frame 77587585.png"
import f5 from "../image1/Frame 77587586.png"
import f6 from "../image1/Frame 77587587.png"
import f7 from "../image1/Frame 77587588.png"
import f8 from "../image1/Frame 77587589.png"
import f9 from "../image1/Frame 77587590.png"

const Data  = [
    {
        id: 1,
        title: "Real Time Scan",
        description: "It scans files in real time when they are opened, copied or modified. It detects and removes the malware, Trojan, and other cyber threats.",
        image: f2,
        style: "bg-radial-gradient1",

    },
    {
        id: 2,
        title: "Mail Protection",
        description: "Automatically detect malicious document and avoid to run in User system. Efficiently blocks emails that might carry infected attachments .",
        image: f1,
        style: "bg-radial-gradient2",

    },
    {
        id: 3,
        title: "USB Protection",
        description: "It scans files in real time when they are opened, copied or modified. It detects and removes the malware, Trojan, and other cyber threats.",
        image: f3,
        style: "bg-radial-gradient3",
    },
    {
        id: 4,
        title: "Ransomware Protection",
        description: "The ransomware protection provides complete protection to your important data against critical ransomware attacks.",
        image: f5,
        style: "",
    },
    {
        id: 5,
        title: "Firewall",
        description: "Firewall blocks external threats that try to reach your computer over the Internet. It also blocks threats that may arise within networks that are connected to your system.",
        image: f6,
        style: "",
    },
    {
        id: 6,
        title: "Webcam Protection",
        description: "Webcam protection prevents unauthorized access to your webcam, safeguarding your privacy from potential spying or hacking attempts.",
        image: f7,
        style: "",
    },
    {
        id: 7,
        title: "Game Booster",
        description: "A game booster optimizes your system's performance by allocating resources, reducing background processes, and enhancing speed for a smoother gaming experience.",
        image: f8,
        style: "",
    },
    {
        id: 8,
        title: "Anti Theft",
        description: "Anti-theft location tracking helps you locate your lost or stolen device in real-time using IP Address",
        image: f9,
        style: "",
    },
    // {
    //     id: 10,
    //     title: "Real Time Scan",
    //     description: "It scans files in real time when they are opened, copied or modified. It detects and removes the malware, Trojan, and other cyber threats.",
    //     image: ""
    // },
    // {
    //     id: 11,
    //     title: "Mail Protection",
    //     description: "Automatically detect malicious document and avoid to run in User system. Efficiently blocks emails that might carry infected attachments or links to compromised or fake and phishing websites.",
    //     image: ""
    // },
    // {
    //     id: 12,
    //     title: "USB Protection",
    //     description: "It scans files in real time when they are opened, copied or modified. It detects and removes the malware, Trojan, and other cyber threats.",
    //     image: ""
    // }
];

export default Data;